import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Cases from "./pages/Cases";
import Resources from "./pages/Resources";
import Reviews from "./pages/Reviews";
import Faq from "./pages/Faq";

export default function App() {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route index element={<Home />} />
				<Route path="about" element={<About />} />
				<Route path="cases" element={<Cases />} />
				<Route path="resources" element={<Resources />} />
				<Route path="reviews" element={<Reviews />} />
				<Route path="faq" element={<Faq />} />

				{/* Unknown paths go back to the home page */}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
		</Routes>
	);
}
